import { render } from "./home-excellence.vue?vue&type=template&id=eaf2065c"
import script from "./home-excellence.vue?vue&type=script&lang=js"
export * from "./home-excellence.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__